var InstallationUpdate = function (
  selectDelivery = false,
  hasInstallation = false,
  installationProduct = "installation",
  isUpdate = false
) {
  
  this.init = function () {
    let cartContents = this.getCart();
    let installation = installation_product;//this.getInstallation();
    let estimator = null;
    let postcode = getCookie("sft_postcode");
    let sft_installation = getCookie("sft_installation");

    if (postcode !== null && postcode !== '') {
      estimator = getCookie("sft_estimator");
      if (
        estimator !== null &&
        estimator !== undefined &&
        estimator !== "" &&
        estimator !== "undefined"
      ) {
        try {
          estimator = JSON.parse(estimator);
        } catch (e) {
          console.error("Invalid estimator JSON:", estimator);
          estimator = null;
        }
      } else {
        let data = new FormData();
        data.append("postcode", postcode);

        estimator = fetch(ESTIMATOR_URL, {
          method: "POST",
          body: data
        })
        .then((response) => response.json())
        .then((data) => {
          return data;
        });
      }
    } 
      // else {
      // For enhance checkout
      // document.querySelector(".enhance-checkout-cart")?.addEventListener("submit", function (e) {
      //   e.preventDefault();
      //   window.location.href = "/pages/select-delivery-installation";
      // });

      // For normal cart page
      // document.querySelector("form.cart")?.addEventListener("submit", function (e) {
      //   e.preventDefault();
      //   window.location.href = "/pages/select-delivery-installation";
      // });
      // }


    Promise.all([installation, cartContents, estimator]).then((values) => {
        let [installation, cart, estimator] = values;
        let itemsToUpdate = { updates: {} };
        let trampoline_count = cart.items.reduce((total, item) => item.product_type == "trampoline" || item.product_type == "Custom Trampoline" || item.product_type == "bundle trampoline" ? total + item.quantity : total,
          0
        );

        console.log('Before hasInstallation',hasInstallation);
        let install_item = cart.items.find((e) => e.handle === "installation");
        hasInstallation = !hasInstallation && install_item !== undefined ? install_item : hasInstallation;
        console.log('trampoline_count',trampoline_count);
        console.log('hasInstallation',hasInstallation);
        console.log('Has Install with trampoline:',(!hasInstallation && trampoline_count > 0));
        document.querySelector(".enhance-checkout-cart")?.addEventListener("submit", function (e) {
          e.preventDefault();
          if (!hasInstallation && trampoline_count > 0) {
            window.location.href = "/pages/select-delivery-installation";
          } else{
            window.location.href = "/checkout";
          }
        });

        if (!hasInstallation && trampoline_count > 0) {
          document.querySelector(".instacart form.cart")?.addEventListener("submit", function (e) {
            e.preventDefault();
            window.location.href = "/pages/select-delivery-installation";
          });
        }
        let variants = installation.variants;
        if (hasInstallation) {
          variants.forEach(function (item, index, arr) {
            if (estimator !== null && ((installationProduct == "installation" && item.title == estimator.install_group))) {
              itemsToUpdate.updates[item.id] = trampoline_count;
            } else {
              itemsToUpdate.updates[item.id] = 0;
            }
          });
        }

        if(sft_installation == 'self'){
          hasInstallation = true;
        }

        let update = this.updateCart(itemsToUpdate);
        Promise.all([update, variants]).then((values) => {
          let hasItem = values[0].items.find((e) => e.handle === "installation");
          // if(hasItem === undefined){
          //   eraseSFTCookie('sft_installation');
          // }
          if(!hasInstallation){
            document.querySelector(".step2 .btn-checkout")?.setAttribute("disabled", "disabled");
          } else {
            document.querySelector(".step2 .btn-checkout")?.removeAttribute("disabled");
          }
          
          let added_variant = null;
          if (values[0].items.length == 0) {
            let cartList = document.querySelector(".navbar-cart-dropdown .navbar-cart-list");
            if( cartList ) {
              cartList.innerHTML = `<li>Your cart is empty.</li>`;
            }
            
            document.querySelector(".mini-cart-count .badge").innerHTML = values[0].item_count;
            document.querySelector(".navbar-cart-total__amount").innerHTML = Shopify.formatMoney(values[0].total_price);
          }

          if (values[0].items.find((e) => e.handle === installationProduct)) {
            values[0].items.forEach((item, index) => {
              if (item.handle == installationProduct) {
                let installation = document.querySelector('.checkout-item-listing [data-variant="' + item.variant_id +'"]');
                added_variant = item.variant_id;
                if (installation !== null) {
                  installation.querySelector(".checkout__num").innerHTML = item.quantity;
                  installation.querySelector(".price").innerHTML = `${item.final_line_price == 0 ? "FREE": Shopify.formatMoney(item.final_line_price)}`;
                }
                
                //Fix for mini cart
                let hasMiniCart = document.querySelector(".navbar-cart-dropdown");
                if (hasMiniCart) {
                  let installationMiniCart = document.querySelector('.navbar-cart-dropdown [data-variant="' + item.variant_id +'"] .navbar-cart-list__price');
                  let installationSelect = document.querySelector('.navbar-cart-dropdown [data-variant="' +item.variant_id +'"] select');
                  if (installationSelect) {
                    installationSelect.value = item.quantity;
                  }
                  if (installationMiniCart) {
                    installationMiniCart.innerHTML = `${Shopify.formatMoney(
                      item.final_line_price
                    )}`;
                  }
                  document.querySelector(".mini-cart-count .badge").innerHTML =
                    values[0].item_count;
                  document.querySelector(
                    ".navbar-cart-total__amount"
                  ).innerHTML = Shopify.formatMoney(values[0].total_price);
                }

                //Cart page fix
                let hasCart = document.querySelector(".instacart__list");
                if (hasCart) {
                  let installationCartPrice = document.querySelector('.instacart__list [data-variant="' +item.variant_id +'"] .price');
                  let installationSelect = document.querySelector('.instacart__list [data-variant="' +item.variant_id +'"] .choices__item--selectable');
                  let installationQty = document.querySelector('.instacart__list [data-variant="' + item.variant_id + '"] .checkout__num');
                  if (installationSelect) {
                    installationSelect.innerHTML = item.quantity;
                  }
                  if (installationQty) {
                    installationQty.innerHTML = item.quantity;
                  }
                  if (installationCartPrice) {
                    installationCartPrice.innerHTML = `${Shopify.formatMoney(item.final_line_price)}`;
                  }
                }

                if (installation == null && selectDelivery) {
                  this.updateInstallation(item);
                }
              }
            });
          }

          values[1].forEach(function (item, index, arr) {
            let install = document.querySelector('.checkout-item-listing [data-variant="' + item.id + '"]');
            let miniCartInstall = document.querySelector('.navbar-cart-dropdown [data-variant="' + item.id + '"]');
            let cartInstall = document.querySelector('.instacart__list [data-variant="' + item.id + '"]');

            if ((miniCartInstall && added_variant !== null && item.id !== added_variant) || values[0].items.length == 0) {
              miniCartInstall?.remove();
            }

            if ((cartInstall && added_variant !== null && item.id !== added_variant) || values[0].items.length == 0) {
              cartInstall?.remove();
            }
            
            if (install && added_variant !== null && item.id !== added_variant) {
              install?.remove();
            }
          });

          let subtotal = document.querySelector(".checkout__subtotal-price");
          let total = document.querySelector(".checkout__total-price .price");
          let checkout_total = document.querySelector(".checkout__total .checkout__total-price .price");

          if (subtotal != null) {
            subtotal.innerHTML = Shopify.formatMoney(values[0].total_price) + " " + values[0].currency;
          }
          if (total != null) {
            total.innerHTML = Shopify.formatMoney(values[0].total_price);
          }
          if (checkout_total != null) {
            checkout_total.innerHTML = Shopify.formatMoney(
              values[0].total_price
            );
          }
        });
      }
    );
  };
  
  this.changeCart = function (formData) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .then((response) => {
        return response;
      });
  };

  this.updateCart = function (itemsToUpdate) {
    return fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(itemsToUpdate),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .then((response) => {
        return response;
      });
  };

  this.updateInstallation = function (item) {
    let _html = `<div class="checkout__item" data-type="${item.product_type}" data-variant="${item.variant_id}">
            <div class="checkout__wrap">
              <div class="checkout__img">
                <span class="checkout__num">${item.quantity}</span>
                <a href="${item.url}">
                  <img class="cart__image" src="${item.featured_image.url.imgURL("x190")}" loading="lazy" alt="${item.featured_image.alt}" data-cart-item-image>
                </a>
              </div>
              <div class="checkout__text">
                <span class="checkout__title">${item.title}</span>
                <p class="stock-message"></p>
              </div>
            </div>
            <div class="checkout__price">
              <div class="position-relative checkout__new">
                <span class="price">${item.final_line_price == 0? "FREE": Shopify.formatMoney(item.final_line_price)}</span>
              </div>
            </div>
          </div>`;

    document.querySelector(".checkout-item-listing .checkout__list").insertAdjacentHTML("beforeend", _html);
  };

  this.getInstallation = function () {
    return installation_product;
  };

  this.getCart = function () {
    return fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
  };
  this.init();
};
new InstallationUpdate();


//Add to cart buton lading...
document.addEventListener('DOMContentLoaded', function () {
  let form = document.querySelector('.product-form');
  if (form) {
    form.addEventListener('submit', function(event) {
      let submitBtn = form.querySelectorAll('.product-form__cart-submit');
      submitBtn.forEach((item,index)=>{
        if(item){
          item.classList.add('disabled');
          item.classList.add('loading');
        }
      });
    });
  }

    document.querySelector('.step1 .btn-primary')?.addEventListener('click', function() {
            this.classList.add('disbaled', 'loading');
  });
  document.querySelector('.step2 .btn-checkout')?.addEventListener('click', function() {
            this.classList.add('disbaled', 'loading');
  });
  document.querySelector('#estimator-postcode')?.addEventListener('input', function() {
        const button = document.querySelector('.step1 .btn-primary');
        if (this.value) {
            button.classList.remove('disbaled', 'loading');
        }
    });
});


